module.exports = __webpack_public_path__ + "media/components/assets/sujung_15-f3c8d76643b76d56ffa281122622d442.png";